import { Component, OnInit, Inject, forwardRef } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { NavigationExtras } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { APIService } from '../../providers/api.service';
import { DetailsService } from '../../providers/details.service';
import { UserDashboardComponent } from 'src/app/user-dashboard/user-dashboard.component';

@Component({
  selector: 'app-private-contest',
  templateUrl: './private-contest.component.html',
  styleUrls: ['./private-contest.component.css'],
  providers: [APIService, DetailsService, UserDashboardComponent]
})
export class PrivateContestComponent implements OnInit {
  decoded: any;
  email: any;
  contestid: any;
  joinContestId: any;
  decodedJoinContestId: any;
  constructor(private localStorageService: LocalStorageService, public detailsService: DetailsService, private APIService: APIService,
    private router: Router, public dialogRef: MatDialogRef<PrivateContestComponent>, @Inject(forwardRef(() => UserDashboardComponent)) public _parent: UserDashboardComponent, ) { }

  ngOnInit() {
    var self = this;
    self.contestid = self.localStorageService.get('contestid');
    self.joinContestId = self.localStorageService.get('joinContestId');
    // console.log(self.joinContestId)
    self.decodedJoinContestId = self.joinContestId === undefined ? "" : window.atob(decodeURIComponent(self.joinContestId)).split('id')[1];
    if (self.decodedJoinContestId) {
      self.contestid = self.decodedJoinContestId;
    }
    if (self.localStorageService.get('referredBy')) {
      var payload = {
        referredBy: self.localStorageService.get('referredBy'),
        userId: self._parent.userId,
        signupType: "Referral-Signup"
      }
      // console.log(payload, "payload")
      self.APIService.doApiCall(function (data) {
        // console.log(data, "data")
        self.decoded = self.localStorageService.get('decoded') ? self.localStorageService.get('decoded') : JSON.parse(localStorage.getItem('lsdecoded'));
        self.email = self.localStorageService.get('email') ? self.localStorageService.get('email') : JSON.parse(localStorage.getItem('lsemail'))
        self.localStorageService.remove('contestid');
        self.localStorageService.remove('decoded');
        self.localStorageService.remove('joinContestId');
        self.localStorageService.remove('isNewUser');
        self.localStorageService.remove('referredBy');
      }, 'api/user/updateReferredUser', 'POST', payload, null)
    } else {
      self.decoded = self.localStorageService.get('decoded') ? self.localStorageService.get('decoded') : JSON.parse(localStorage.getItem('lsdecoded'));
      self.email = self.localStorageService.get('email') ? self.localStorageService.get('email') : JSON.parse(localStorage.getItem('lsemail'))
      self.localStorageService.remove('contestid');
      self.localStorageService.remove('decoded');
      self.localStorageService.remove('joinContestId');
      self.localStorageService.remove('isNewUser');
      self.localStorageService.remove('referredBy');
    }
  }

  ok = function () {
    // $uibModalInstance.close();
    var self = this
    self.dialogRef.close();
    
    self.APIService.doApiCall(function (data) {
      if (data.Data.roleId === self.detailsService.loginAdmin || data.Data.roleId === self.detailsService.loginSuperAdmin) {
        //if admin redirect to 
        // $state.go('adminDashboard.home');
        self.router.navigate(['/dashboard/home']);
      }
      let name = data.Data.firstName;
      let userId = data.Data.userId;
      let roleId = data.Data.roleId;
      var payload = {
        "userId": Number(userId),
        "contestId": Number(self.contestid)
      }
      self.APIService.doApiCall(function (data) {
        if (data.StatusCode == 'SG001') {
          // $state.go('user.makeStatement', { tId: decoded });
          self.router.navigate(['/user/makeStatement/' + self.joinContestId]);
          // console.log(['/user/makeStatement/' + self.joinContestId])
        } else if (data.StatusCode == 'SG132' || data.StatusCode == 'SG157' || data.StatusCode == 'SG166' || data.StatusCode == 'SG139') {
          //not having enough coin
          // $state.go('user.joincontest', { errorMsg: data.Message });
          let errorMsg1: NavigationExtras = {
            queryParams: {
              "errorMsg": data.Message
            }
          };
          self.router.navigate(['/user/joincontest'], errorMsg1);
          // $timeout(function () {
          //   $state.go('user.lobby');
          // }, 5000);

          setTimeout(() => {
            self.router.navigate(['/user/lobby']);
          }, 5000);
        }
      }, 'api/contest/private/join?requestedBy=' + userId, 'POST', payload, null);

      

    }, 'api/profile/userinfo?email=' + self.email, 'GET', null, null);
  }

  close = function () {
    var self = this
    // $uibModalInstance.dismiss();
    self.dialogRef.close();
    // $state.go('user.lobby');  
    self.router.navigate(['/user/lobby']);

  }
}
